import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 120 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_958_6305)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 120,
				height: 120,
				fill: "#FFFFFE"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 120,
				height: 120,
				fill: "url(#paint0_linear_958_6305)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.9776 75V45.9091H46.239V50.9801H33.1282V57.9119H44.9606V62.983H33.1282V75H26.9776ZM50.2624 75V53.1818H56.3136V75H50.2624ZM53.3022 50.3693C52.4026 50.3693 51.6308 50.071 50.9869 49.4744C50.3524 48.8684 50.0352 48.1439 50.0352 47.3011C50.0352 46.4678 50.3524 45.7528 50.9869 45.1562C51.6308 44.5502 52.4026 44.2472 53.3022 44.2472C54.2018 44.2472 54.9689 44.5502 55.6033 45.1562C56.2473 45.7528 56.5692 46.4678 56.5692 47.3011C56.5692 48.1439 56.2473 48.8684 55.6033 49.4744C54.9689 50.071 54.2018 50.3693 53.3022 50.3693ZM67.212 45.9091V75H61.1609V45.9091H67.212ZM82.0025 75.4261C79.7582 75.4261 77.8263 74.9716 76.207 74.0625C74.5972 73.1439 73.3567 71.8466 72.4854 70.1705C71.6142 68.4848 71.1786 66.4915 71.1786 64.1903C71.1786 61.946 71.6142 59.9763 72.4854 58.2812C73.3567 56.5862 74.583 55.2652 76.1644 54.3182C77.7553 53.3712 79.6209 52.8977 81.761 52.8977C83.2004 52.8977 84.5404 53.1297 85.7809 53.5938C87.0309 54.0483 88.1199 54.7348 89.0479 55.6534C89.9854 56.572 90.7146 57.7273 91.2354 59.1193C91.7563 60.5019 92.0167 62.1212 92.0167 63.9773V65.6392H73.5934V61.8892H86.3207C86.3207 61.018 86.1313 60.2462 85.7525 59.5739C85.3737 58.9015 84.8481 58.3759 84.1758 57.9972C83.5129 57.6089 82.7411 57.4148 81.8604 57.4148C80.9419 57.4148 80.1275 57.6278 79.4173 58.054C78.7165 58.4706 78.1673 59.0341 77.7695 59.7443C77.3718 60.4451 77.1682 61.2263 77.1587 62.0881V65.6534C77.1587 66.733 77.3576 67.6657 77.7553 68.4517C78.1625 69.2377 78.7354 69.8438 79.4741 70.2699C80.2127 70.696 81.0887 70.9091 82.1019 70.9091C82.7743 70.9091 83.3898 70.8144 83.9485 70.625C84.5072 70.4356 84.9854 70.1515 85.3832 69.7727C85.7809 69.3939 86.0839 68.9299 86.2923 68.3807L91.8889 68.75C91.6048 70.0947 91.0224 71.2689 90.1417 72.2727C89.2705 73.267 88.1436 74.0436 86.761 74.6023C85.3879 75.1515 83.8017 75.4261 82.0025 75.4261Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_958_6305",
		x1: 512,
		y1: 512,
		x2: 512,
		y2: 0,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#009999" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#009999"
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_958_6305",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 120,
			height: 120,
			fill: "white"
		})
	})] })]
});
export { SvgFileLogo as ReactComponent };
